(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function update(bar) {
    const viewport = bar.querySelector('.le-announcement__viewport');
    const track = bar.querySelector('.le-announcement__track--animated');
    if (!viewport || !track) return;

    const [first, second] = track.querySelectorAll('.le-announcement__group');
    if (!first || !second) return;

    first.querySelectorAll('[data-announcement-clone]').forEach((item) => item.remove());
    const originals = [...first.children];
    if (!originals.length) return;

    if (!reducedMotion.matches) {
      let index = 0;
      while (first.offsetWidth + parseFloat(getComputedStyle(first).marginRight) < viewport.clientWidth && index < 48) {
        const clone = originals[index % originals.length].cloneNode(true);
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('data-announcement-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((link) => { link.tabIndex = -1; });
        first.append(clone);
        index += 1;
      }
    }

    second.replaceChildren(...[...first.children].map((item) => {
      const clone = item.cloneNode(true);
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('a').forEach((link) => { link.tabIndex = -1; });
      return clone;
    }));
    const shift = first.offsetWidth + parseFloat(getComputedStyle(first).marginRight);
    track.style.setProperty('--announcement-shift', `${shift}px`);
  }

  function init(bar) {
    if (bar.dataset.announcementLoopReady) return;
    bar.dataset.announcementLoopReady = 'true';
    const refresh = () => update(bar);
    new ResizeObserver(refresh).observe(bar);
    reducedMotion.addEventListener('change', refresh);
    refresh();
  }

  document.querySelectorAll('[data-announcement-bar]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-announcement-bar]').forEach(init);
  });
})();
